import styled from 'styled-components';

interface IPartyJackpotInGameWidgetContainerProps {
    active?: boolean;
}

export const PartyJackpotInGameWidgetContainerBox = styled.div<IPartyJackpotInGameWidgetContainerProps>`
    position: relative;
    background: url(${props => props.theme.images.liveParty.in_game_widget_background.toString()});
    background-repeat: no-repeat;
    background-position: center top;
    background-size: contain;
    cursor: pointer;
    width: 214px;
    height: 172px;
    @media ${(props) => props.theme.mediaQuery.xlExact} {
        width: 160px;
        height: 129px;
    }
    @media ${(props) => props.theme.mediaQuery.lAndBelow} {
        width: 100px;
        height: 84px;
    }
`;
